import * as React from "react";
import Tab from "./Tab";
import TabItem from "./TabItem";
import { idfServiceIds, ezsServiceIds } from "../../../config/UserServicesList";
import { useAreServicesActive } from "../../../util/CommonServices";
import { CommonContext } from "../../../CommonContextProvider";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useTranslation } from "react-i18next";
import LogoContainer from "../LogoContainer";

const ProtectionTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const monitoringServiceids = [
        idfServiceIds.darkWebMonitoring,
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        idfServiceIds.socialMediaMonitoring,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebPhiBot,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.changeOfAddressMonitoring,
        ezsServiceIds.tuCriminalMonitoring,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.sexOffenderMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.tuAdvancedFraudMonitoring,
        ezsServiceIds.tuChangeOfAddressMonitoring,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
    ];
    const isMonitoringActive = useAreServicesActive(monitoringServiceids);
    const isPasswordsAvailable = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isPasswordsAvailable
            ? state.configurationState.configuration.partnerConfig.isPasswordsAvailable
            : false
    );

    return (
        <Tab tabId="identity-vault-tabs">
            <TabItem title="Risk Management" link="/protection" tabNo="1" selectedTab={props.selectedTab} />
        </Tab>
    );
};

export default ProtectionTab;
